import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { EncounterReportControllerApi } from "../../services";
import { getConfigObject, getXtenantId, useBaseData } from "../../utils/utils";

interface UsePatientEncounterDashboardStatsProps {
  startDate?: string;
  endDate?: string;
  providerUuid?: Array<string>;
  locationUuid?: Array<string>;
  providerGroupId?: string | null;
}

/**
 * @description Hook for fetching patient encounter dashboard KPI stats
 */
export function usePatientEncounterDashboardStats({
  startDate,
  endDate,
  providerUuid,
  locationUuid,
  providerGroupId,
}: UsePatientEncounterDashboardStatsProps): useBaseData<any> {
  return useQuery({
    queryKey: [
      "patient-encounter-dashboard-stats",
      startDate,
      endDate,
      providerUuid,
      locationUuid,
    ],
    enabled: !!providerGroupId,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new EncounterReportControllerApi(getConfigObject())
        .getEncounterReportDashboard(
          startDate,
          endDate,
          providerUuid,
          locationUuid,
          undefined,
          undefined,
          providerGroupId ?? getXtenantId()
        )
        .then((res) => res?.data),
  });
}
